import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { WorkWidgetHeaderModule } from 'shared/components/work-widget-header/work-widget-header.module';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { NanorepPanelModule } from 'shared/components/nanorep-panel/nanorep-panel.module';
import { CannedMessageModule } from 'shared/components/canned-message-panel/canned-message-panel.module';
import { VisitorHistoryModule } from 'shared/components/visitor-history/visitor-history.module';
import { RefreshableFrameModule } from 'shared/components/refreshable-frame/refreshable-frame.module';
import { SalesforceLaneModule } from 'shared/components/salesforce-lane/salesforce-lane.module';
import { WebConsoleContainerModule } from '../shared/components/web-console-container/web-console-container.module';
import { TextChatWidgetComponent } from './text-chat-widget.component';
import { LoadingModule } from '../../../../../shared/components/loading/loading.module';
import { TextChatBoxModule } from './text-chat-box/text-chat-box.module';
import { DetailedDataModule } from 'shared/components/detailed-data/detailed-data.module';
import { AssignmentHistoryModule } from 'shared/components/assignment-history/assignment-history.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    WorkWidgetHeaderModule,
    SvgIconModule,
    NanorepPanelModule,
    CannedMessageModule,
    VisitorHistoryModule,
    AssignmentHistoryModule,
    DetailedDataModule,
    RefreshableFrameModule,
    SalesforceLaneModule,
    WebConsoleContainerModule,
    LoadingModule,
    TextChatBoxModule
  ],
  declarations: [
    TextChatWidgetComponent
  ],
  exports: [
    TextChatWidgetComponent
  ]
})
export class TextChatWidgetModule {}
